module.exports = __webpack_public_path__ + "img/ring_r_l_0_1@2x.b6e43b97.png";